<template>
  <b-modal
    v-model="show"
    centered
    hide-header
    hide-footer
    id="responsive-modal"
    @change="onchange"
  >
    <div v-if="title" class="d-flex justify-content-center text-center">
      <h3>{{ title }}</h3>
      <div class="button-close" @click="close">
        <i class="ph-bold ph-x fs-16" />
      </div>
    </div>
    <div class="slot-content">
      <slot />
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      show: this.value
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    }
  },
  watch: {
    value(val) {
      this.show = val;
    }
  },
  methods: {
    close() {
      this.show = false;
      this.$emit("input", false);
    },
    onchange(v) {
      this.show = v;
      this.$emit("input", v);
    }
  }
};
</script>
<style lang="scss" scoped>
h3 {
  font-size: 32px;
  font-weight: 600;
  width: calc(100% - 96px);
  margin-bottom: 40px;

  @media screen and (max-width: 991px) {
    font-size: 24px;
  }
}
.slot-content {
  padding: 80px;
  background: var(--bg-1);
  border-radius: 32px;

  @media screen and (max-width: 991px) {
    padding: 24px !important;
  }
}

.button-close {
  background-color: var(--dark-4);
  border-radius: 12px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0px;
  height: 40px;
  width: 40px;

  &:hover {
    background-color: var(--dark-20);
    cursor: pointer;
  }
}
</style>
